import { createSlice } from "@reduxjs/toolkit";

import { EstablishmentSettingsModel } from "../models/interfaces/establishment-settings-model";


const initialState: EstablishmentSettingsModel = {
  accountName: "",
  terminologies: [],
};

export const establishmentSettingsSlice = createSlice({
  name: "establishmentSettings",
  initialState: initialState,
  reducers: {
    setEstablishmentSettings: (currentState, action) => {
      return action.payload;
    },
  }
})

export const { 
  setEstablishmentSettings
} = establishmentSettingsSlice.actions;
  
export default establishmentSettingsSlice.reducer;